<template>
    <div class="general_wrapper">
        <np-navbar :permissions="user_permissions" :user="user" :menu-items="navbarToRender" :alliance_support="alliance_support" :my_language="my_language"
        :language_options="alliance_supported_languages"></np-navbar>
        <div :class="{'self-boarding': showTitle}">
            <div class="container self-boarding--title" v-if="showTitle">
                <h1>{{lang(applicationPageTitle)}}</h1>
            </div>
            <!-- main container -->
            <div class="container main_contentContainer">
                <div class="gp_mask ready">
                </div>
                    <notifications position="top center" width="500px" class="np-notification vue-notification-up">
                      <template #body="props">
                        <div class="vue-notification-template" :class="props.class">
                          <div class="notification-title">{{ props.item.title }}</div>
                          <div class="notification-content">
                            <div v-html="props.item.text"/>
                          </div>
                        </div>
                      </template>
                    </notifications>
                <div class="contentOuter">
                    <router-view>

                    </router-view>
                </div>

                </div> <!-- end of main container -->

            </div>
    </div>
</template>

<script>
//TODO lazy load leftmobile component for mobile view navbar.
//TODO build topnav component from user permissions set it in Homecontroller.
//Home controller is the entry point for whole project.
//pass user permissions in vue_data to develop top nav.

import NPNavbar from '../components/np-navbar.vue'
import {mapActions, mapState} from "pinia";
import useModuleStore from "../stores";
import useApplicationStore from "../stores/application_module";
import * as types from "../stores/constants";
import navigationMixin from "../utils/navigation-mixin";

    export default {
        name: "App.vue",
        components: {
            'np-navbar': NPNavbar,
        },
        mixins: [navigationMixin],
        data: () => {
            return {
                showTitle: true,
                navItems: [
                    {
                        icon: 'las la-folder-open la-rotate-270',
                        label: LANGUAGE['your_applications'],
                        link: 'application/add',
                        entry_point: '/business/',
                        id: 'your_application',
                        url: '',
                        display: true,
                    }
                ],
                alliance_support: {},
                alliance_supported_languages: []
            }
        },
        created() {
            this.commitVueData();
        },
        computed: {
            ...mapState(useApplicationStore, {applicationPageTitle:'applicationPageTitle'}),
            ...mapState(useModuleStore,{
                user:'user',
                parameters:'parameters',
                is_loading:'is_loading',
                merchant_user_access:'merchant_user_access',
                dashboard:'dashboard',
                user_permissions:'user_permissions',
                workflow_permissions:'workflow_permissions',
                error_message:'error_message',
                my_language:'my_language'}),
            navbarToRender: function () {
                let tabs = [], vm = this;
                this.navItems.forEach(tab => {
                    if (tab.id === 'your_application') {
                        if (vm.unfinished_entity !== '') { //they have an open quote or application
                            tab.url = vm.unfinishedEntityLink
                        }
                        else if (vm.unfinished_entity == '' && !!this.merchant_user_access && this.merchant_user_access.hasOwnProperty('application')
                            && this.merchant_user_access.application.length > 0 && vm.isSignerUser && this.merchant_user_access.hasOwnProperty('signer_to_upload_document')
                            && this.merchant_user_access.signer_to_upload_document) {

                            let is_bank_id_verify_configured = vm.isBankIdWorkflowConfigured();
                            let application = this.merchant_user_access.application[0];

                            if (is_bank_id_verify_configured) {
                              tab.url  = `/application/view/${application.application_reference}/business_details/principals`;
                            } else {
                              tab.url = `/application/view/${application.application_reference}/upload_documents/`;
                            }
                        }
                        //both quote and application are completed
                        else if (vm.unfinished_entity === '' && !!this.merchant_user_access && this.merchant_user_access.hasOwnProperty('application')
                            && this.merchant_user_access.application.length > 0) {
                            //we should only have one finished application. If we  have  more  than one then we should have a filter table.
                            let application = this.merchant_user_access.application[0];
                            tab.url = `/application/view/${application.application_reference}/review/`;
                        }
                        //fresh application
                        else {
                            tab.url = `/${tab.link}${tab.entry_point}`;
                        }

                        let uri = tab.url.split('/').slice(1,3).join('/'); // application/edit
                        tab.display = this.isPermittedUrl(uri)

                        tabs.push(tab)
                    }
                })
                return tabs;
            },
            isPublicUser: function () {
                return this.user.is_public_user == '1';
            },
            isSignerUser: function () {
                return this.user.is_signer_user == '1';
            },
/*            unfinished_application: function () {
                return !this.isPublicUser && !!this.dashboard.unfinished && this.dashboard.unfinished.hasOwnProperty('application') &&
                this.objectIsNotEmpty(this.dashboard.unfinished.application) ? this.dashboard.unfinished.application : {};
            },
            unfinished_quote: function (){
                return !this.isPublicUser && !!this.dashboard.unfinished && this.dashboard.unfinished.hasOwnProperty('quote') &&
                this.objectIsNotEmpty(this.dashboard.unfinished.quote) ? this.dashboard.unfinished.quote : {};
            },
            unfinished_entity: function () {
                let entity = '';

                if (this.objectIsNotEmpty(this.unfinished_quote)) {
                    entity = 'quote';
                } else if (this.objectIsNotEmpty(this.unfinished_application)) {
                    entity = 'application';
                }
                return entity;
            },
            unfinishedEntityLink: function () {
                let path = ''
                if (this.unfinished_entity === 'quote') {
                    path = '/quote/edit/' + this.unfinished_quote.quote_external_id + '/business/';
                }
                if (this.unfinished_entity === 'application') {
                    //Check that the logged in user is the merchant owner
                    let action = 'edit', endpoint = 'business_details';
                    if (this.unfinished_application.sales_owner_user_external_id !== this.user.user_external_id) {
                        action = this.unfinished_application.hasOwnProperty('merchant_owner_user_external_id') &&
                        this.unfinished_application.merchant_owner_user_external_id === this.user.user_external_id && (this.unfinished_application.hasOwnProperty('merchant_control') && this.unfinished_application.merchant_control === '1') ?
                            'edit' : 'view';
                    }

                    //merchant has not control (to edit), so go to review page first
                    let merchant_in_control = this.unfinished_application.hasOwnProperty('merchant_control')
                        && (this.unfinished_application.merchant_control === '1');
                    if (!merchant_in_control) {
                        action = 'view';
                        endpoint = 'review';
                    }

                    //Upload document might override the previous action&endpoint. Higher priority.
                    //Seller specified merchant to upload document when seller did submission, that means the only action left is upload document
                    let vm = this;
                    let merchant_to_upload_document = (vm.unfinished_application.hasOwnProperty('merchant_to_upload_document')
                        && (vm.unfinished_application.merchant_to_upload_document === '1'));
                    let is_bank_id_verify_configured = vm.isBankIdWorkflowConfigured();
                    //console.log("is_bank_id_verify_configured",is_bank_id_verify_configured);
                    if (merchant_to_upload_document) {
                        if (merchant_in_control) {
                            action = 'edit';
                            endpoint = 'documents';
                            if (is_bank_id_verify_configured) {
                                endpoint = 'business_details/principals';
                            }
                        }
                        else {
                            action = 'view';
                            endpoint = 'upload_documents';
                            if (is_bank_id_verify_configured) {
                                endpoint = 'business_details/principals';
                            }
                        }
                    }

                    //GDPR might override the previous action&endpoint. Higher priority.
                    //begin gdpr process. Matched cases will return path directly, otherwise remain the decision above
                    let merchant_has_not_confirmed_gdpr = !(this.unfinished_application.hasOwnProperty('has_merchant_confirmed_gdpr')
                        && (this.unfinished_application.has_merchant_confirmed_gdpr === '1'));
                    let is_application_validated = this.unfinished_application.hasOwnProperty('is_validated')
                        && (this.unfinished_application.is_validated === '1');
                    if (merchant_has_not_confirmed_gdpr) {
                        if (action === 'edit') {
                            //always go to business info page for merchant to confirm gdpr
                            endpoint = types.URL_BUSINESS_INFO;
                            path = '/quote/' + action + '/' + this.unfinished_application.quote_external_id + '/'+ endpoint +'/';
                            return path;
                        }
                        else if (action === 'view' && is_application_validated && !merchant_to_upload_document) {
                            // go to review page for merchant to confirm gdpr if application is validated and documents have been uploaded.
                            endpoint = types.URL_SUBMISSION_REVIEW;
                            path = '/application/' + action + '/' + this.unfinished_application.application_reference + '/'+ endpoint +'/';
                            return path;
                        }
                    }
                    //end gdpr process

                    path = '/application/' + action + '/' + this.unfinished_application.application_reference + '/'+ endpoint +'/';
                }

                //block a loophole where the quote is not assigned to the merchant but they have merchant_user_access
                if (this.unfinished_entity === ''){
                    if (this.merchant_user_access.hasOwnProperty('quote')){
                        let quote = this.merchant_user_access.quote[0];
                        let action = quote.status_id === '1' ? 'edit' :'view';
                        path = '/quote/' + action + '/' +quote.quote_external_id + '/business/';
                    }

                    if (this.merchant_user_access.hasOwnProperty('application')){
                        let application = this.merchant_user_access.application[0], endpoint = '';
                        let application_status = this.parameters.APPLICATION_STATUS_PARAM.find(obj => {
                           return obj.application_status_external_id === application.application_status_external_id
                        })

                        let action = !!application_status && application_status.application_status_key === 'OPEN' ? 'edit' : 'view';

                        path = '/application/' + action + '/' + application.application_reference + '/business_details/';

                        if (application.hasOwnProperty('merchant_to_upload_document') && application.merchant_to_upload_document === '1'){
                            let is_bank_id_verify_configured = this.isBankIdWorkflowConfigured();
                            action = 'view';
                            endpoint = 'upload_documents';
                            if (is_bank_id_verify_configured) {
                                endpoint = 'business_details/principals';
                            }

                            if (application.hasOwnProperty('merchant_control') && application.merchant_control === '1') {
                                action = 'edit';
                                endpoint = 'documents';
                                if (is_bank_id_verify_configured) {
                                    endpoint = 'business_details/principals';
                                }
                            }
                        }

                        //begin gdpr process. Matched cases will return path directly, otherwise remain the decision above
                        let merchant_has_not_confirmed_gdpr = !(application.hasOwnProperty('has_merchant_confirmed_gdpr')
                            && (application.has_merchant_confirmed_gdpr === '1'));
                        let is_application_validated = application.hasOwnProperty('is_validated')
                            && (application.is_validated === '1');
                        if (merchant_has_not_confirmed_gdpr) {
                            if (action === 'edit') {
                                //always go to business info page for merchant to confirm gdpr
                                endpoint = types.URL_BUSINESS_INFO;
                                path = '/quote/' + action + '/' + application.quote_external_id + '/'+ endpoint +'/';
                                return path;
                            }
                            else if (action === 'view' && is_application_validated) {
                                // go to business info page for merchant to confirm gdpr
                                endpoint = types.URL_SUBMISSION_REVIEW;
                                path = '/application/' + action + '/' + application.application_reference + '/'+ endpoint +'/';
                                return path;
                            }
                        }
                        //end gdpr process

                        path = '/application/' + action + '/' + application.application_reference + '/'+ endpoint +'/';
                    }
                }

                return path;
            }*/
        },
        methods: {
            ...mapActions(useApplicationStore,[types.SET_LOGGED_IN_USER]),
            ...mapActions(useModuleStore,[types.SET_PARAMETERS,types.SET_BRANDING,types.TOGGLE_LOADING,types.SET_MERCHANT_USER_ACCESS,types.SET_USER_PERMISSIONS
            , types.SET_WORKFLOW_PERMISSIONS,types.SET_MY_LANGUAGE, types.SET_DASHBOARD_DATA, types.SET_ALLIANCE_DATA, types.SET_SUPPORT_PHONE]),
            commitVueData: function () {
                const store = useModuleStore();
                let user = vue_data.hasOwnProperty('user') ? vue_data.user : {};
                let my_language = vue_data.hasOwnProperty('my_language') ? vue_data.my_language : {};
                let parameters = vue_data.hasOwnProperty('parameters') ? vue_data.parameters : {};
                let merchant_user_access = vue_data.hasOwnProperty('merchant_user_access') ? vue_data.merchant_user_access : {};
                let branding = parameters.hasOwnProperty('BRANDING') ? parameters.BRANDING : {};
                let user_permissions = parameters.hasOwnProperty('USER_PERMISSIONS') && this.objectIsNotEmpty(parameters.USER_PERMISSIONS) ? parameters.USER_PERMISSIONS : {};
                let workflow_permissions = parameters.hasOwnProperty('WORKFLOW_PERMISSIONS') && this.objectIsNotEmpty(parameters.WORKFLOW_PERMISSIONS) ? parameters.WORKFLOW_PERMISSIONS : {};
                let dashboard = vue_data.hasOwnProperty('dashboard') ? vue_data.dashboard : {};
                let alliance = vue_data.hasOwnProperty('alliance') ? vue_data.alliance : {};
                this.alliance_support = vue_data.hasOwnProperty('alliance_support') ? vue_data.alliance_support : {};

                this.setAllianceSupportedLanguages(alliance);

                store[types.SET_LOGGED_IN_USER](user);
                store[types.SET_MY_LANGUAGE](my_language);
                store[types.SET_PARAMETERS](parameters);
                store[types.SET_BRANDING](branding);
                store[types.SET_USER_PERMISSIONS](user_permissions);
                store[types.SET_WORKFLOW_PERMISSIONS](workflow_permissions);
                store[types.SET_MERCHANT_USER_ACCESS](merchant_user_access);
                store[types.SET_DASHBOARD_DATA](dashboard);
                store[types.SET_ALLIANCE_DATA](alliance);

                let support_phone = this.formatSupportPhone();
                store[types.SET_SUPPORT_PHONE](support_phone)
            },
            isPermittedUrl: function (url) {
                if(this.objectIsNotEmpty(this.parameters)) {
                    let user_permissions = this.parameters.USER_PERMISSIONS;
                    let workflow_permissions = this.parameters.WORKFLOW_PERMISSIONS;

                    if (!user_permissions.hasOwnProperty(url)) {
                        return false;
                    } else {
                        if (user_permissions[url] == '1') {
                            if (workflow_permissions.hasOwnProperty(url)) {
                                return true
                            }
                            return false;
                        }
                        return true;
                    }
                }
            },

            logout: function () {
                this.getAxiosInstance().post('/login/logout').then(response => {
                    location.href= '/login';
                });
            },
            setAllianceSupportedLanguages: function (alliance) {
                if (alliance.hasOwnProperty('allowed_alt_languages') && alliance.allowed_alt_languages !== '') {
                    this.alliance_supported_languages = alliance.allowed_alt_languages.split(',');
                } else {
                    this.alliance_supported_languages = ['en_gb']
                }
            },
            formatSupportPhone: function () {
                let formatted_support_phone = '0000 000 0000';
                let alliance = vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;

                if (alliance && alliance.hasOwnProperty('support_phone') && !!(alliance.support_phone)) {

                    let phone_no = alliance.support_phone;
                    if (phone_no.length >= 7) {
                        formatted_support_phone = phone_no.substring(0, 4) + ' ' + phone_no.substring(4, 7)
                            + ' ' + phone_no.substring(7, phone_no.length);
                    }
                    else {
                        formatted_support_phone = phone_no;
                    }

                    if (alliance.hasOwnProperty('support_phone_code') && !!(alliance.support_phone_code)) {
                        let phone_code = !!alliance.support_phone_code ? this.formatPhoneCode(alliance.support_phone_code) : '';
                        formatted_support_phone = phone_code + ' ' + formatted_support_phone;
                    }
                }
                return formatted_support_phone;
            },
            formatPhoneCode: function (data) {
                if (!!data && data !== "") {
                    return this.formatSelectType(this.parameters, data, 'PHONE_CODES')
                }
                return '';
            },
            isMerchantViewAndUpdateDocument: function (unfinished_application) {
                let merchant_to_upload_document = !!unfinished_application
                    && unfinished_application.hasOwnProperty('merchant_to_upload_document')
                    && unfinished_application.merchant_to_upload_document === '1';
                let merchant_in_control = !!unfinished_application
                    && unfinished_application.hasOwnProperty('merchant_control')
                    && unfinished_application.merchant_control === '1';

                return merchant_to_upload_document && !merchant_in_control;
            },
            isBankIdWorkflowConfigured: function () {
                let parameters = vue_data && vue_data.hasOwnProperty('parameters') ? vue_data.parameters : null;
                if (parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK') && !!parameters.APPLICATION_PROCESS_ACTIONS_CHECK) {
                    let workflow_actions = parameters.APPLICATION_PROCESS_ACTIONS_CHECK;
                    return workflow_actions.BANK_ID_VERIFICATION === true;
                }
                return false;
            },

        },
        watch: {
            is_loading: function (newVal, oldVal) {
                if(newVal === true) {
                    if (oldVal !== true) {
                        objCommon.generalPreloader.show_pl($('.alert.alert-confirmation'), false, false, LANGUAGE['processing']);
                    }
                } else {
                    objCommon.generalPreloader.hide_pl();
                }
            },
            error_message: function (val) {
                if (val !== '') {
                    this.notifyError(this.lang('validation_error'), val)
                }
            }
        }
    }
</script>

<style scoped>
 .vue-notification-group {
     z-index: 999999;
 }
 @media (max-width: 768px) {
   .vue-notification-group {
     width: 100%;
   }
 }
</style>